import { ParagraphSM } from '@/atoms/Text'
import { ReactFCC } from '@/types/react'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import {
  TorchApplicationSubmissionHeader,
  TorchApplicationSubmissionHeaderProps,
} from './TorchApplicationSubmissionHeader'

export const Page: ReactFCC<TorchApplicationSubmissionHeaderProps> = ({ children, ...props }) => {
  const { t } = useTranslate('guild-create')
  return (
    <>
      <TorchApplicationSubmissionHeader {...props} />
      <div className="flex w-full max-w-5xl flex-col items-center gap-8 px-4">{children}</div>
      <div>
        <ParagraphSM color="core-gray-500" className="text-center">
          <Translate
            t={t}
            i18nKey="needHelpWithYourSubmissionContactTanner"
            values={{ email: 'tanner.nash@angel.com' }}
          >
            Need help with your submission? Contact{' '}
            <a href="mailto:tanner.nash@angel.com" className="underline hover:text-core-gray-950">
              tanner.nash@angel.com.
            </a>
          </Translate>
        </ParagraphSM>
      </div>
    </>
  )
}
